import React, { Component } from 'react';
import PT from 'prop-types';
import { MDCSelect } from './material-design-hacks/mdc-select';
import cIf from 'classnames';
import { map } from 'lodash';

export class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.mdSelectRef = React.createRef();
    }

    componentDidMount() {
        let select = new MDCSelect(this.mdSelectRef.current);
        select.listen("MDCSelect:change", () => {
            this.props.onChange(select.value);
        });
    }
    
    prepareItem(item, index) {
        return (
            <li
                key={"item" + index}
                className={cIf(["mdc-list-item", { "mdc-list-item--selected": item[this.props.valueField] === this.props.value }])}
                aria-selected={item[this.props.valueField] === this.props.value}
                role="option"
                data-value={item[this.props.valueField]}>
                    {item[this.props.textField]}
            </li>
        );
    }

    render() {
        let options;
        if (this.props.usesSections) {
            options = map(this.props.items, (section) => {
                let items = map(section[this.props.sectionItemsField], (item, index) => {
                    return this.prepareItem(item, index);
                });

                if (this.props.selectableSections)
                    return <div key={"section_" + section[this.props.sectionTextField]} className="rese-select-selectable-section">
                        <li className={cIf(["section-name mdc-list-item", { "mdc-list-item--selected": section[this.props.sectionValueField] === this.props.value }])}
                            aria-selected={section[this.props.sectionValueField] === this.props.value}
                            role="option"
                            data-value={section[this.props.sectionValueField]}>{section[this.props.sectionTextField]}</li>
                        <ul>{items}</ul>
                    </div>;
    
                return <div key={"section_" + section[this.props.sectionTextField]} className="rese-select-section">
                    <span>{section[this.props.sectionTextField]}</span>
                    {items}
                </div>;
            });
        } else {
            options = map(this.props.items, (item, index) => {
                return this.prepareItem(item, index);
            });
        }

        return (
            <div className={cIf(["mdc-select", "rese-select", { "rese-select--full-width": this.props.isFullWidth }])} ref={this.mdSelectRef}>
                <div className="mdc-select__anchor">
                    <i className="rese-select-dropdown-icon mdc-select__dropdown-icon"></i>
                    <span 
                        id="select-label"
                        className={cIf(
                            ["rese-floating-label mdc-floating-label", { "mdc-floating-label--float-above": this.props.value !== "" && this.props.value !== null }]
                        )}
                    >
                        {this.props.placeholder}
                    </span>
                    <div 
                        id="select-value"
                        className="mdc-select__selected-text" 
                        role="button"
                        aria-haspopup="listbox" aria-labelledby="select-label select-value"
                    >
                        {this.props.value}
                    </div>
                    <div className="mdc-line-ripple" />
                </div>
                
                <div className="mdc-select__menu mdc-menu mdc-menu-surface" role="listbox">
                    <ul className={cIf(["rese-select-list mdc-list", {"larger-list": this.props.isLarger}])}>
                        {options}
                    </ul>
                </div>
            </div>
        );
    }
}
Dropdown.propTypes = {
    name: PT.string,
    placeholder: PT.string,
    items: PT.oneOfType([
        //PT.arrayOf(PT.shape(PT.any, PT.arrayOf(PT.object))), // sections d'items. C'est mal fait caa
        PT.arrayOf(PT.any) // items
    ]),
    value: PT.string,
    valueField: PT.oneOfType([PT.string, PT.number]),
    textField: PT.string,
    sectionTextField: PT.string,
    sectionValueField: PT.oneOfType([PT.string, PT.number]),
    sectionItemsField: PT.string,
    onChange: PT.func,
    isFullWidth: PT.bool,
    usesSections: PT.bool,
    isLarger: PT.bool,
    selectableSections: PT.bool
};
Dropdown.defaultProps = {
    name: "dropdown1",
    isFullWidth: false, 
    usesSections: false,
    isLarger: false,
    selectableSections: false
};
